import * as React from 'react';
import { CLASSNAME_PREFIX as cp } from '../componentConfig';
import './VerificationErrorPage.scss';
var VerificationErrorPage = function (_a) {
    var firstName = _a.firstName;
    return (React.createElement("div", { className: cp + "-verification-error" },
        React.createElement("div", { className: cp + "-verification-error__icon" },
            React.createElement("div", null)),
        React.createElement("div", null,
            React.createElement("p", { className: cp + "-verification-error__title" }, "You\u2019re almost there"),
            React.createElement("p", { className: cp + "-verification-error__message" },
                "Hi ",
                firstName,
                ","),
            React.createElement("p", { className: cp + "-verification-error__message" }, "We were unable to verify your account via our Auto Verification tool so, your documents are currently being reviewed by our dedicated team."),
            React.createElement("p", { className: cp + "-verification-error__message" }, "This can take up to 24 hours and we will email you to confirm if your account verification was successful."),
            React.createElement("p", { className: cp + "-verification-error__message" },
                "Check out our",
                ' ',
                React.createElement("a", { target: "_blank", href: "https://www.williamhill.com/app/answers/detail/a_id/28801/kw/verification" }, "FAQ for Verification here.")))));
};
export default VerificationErrorPage;
//# sourceMappingURL=VerificationErrorPage.js.map